import { render, staticRenderFns } from "./InformasiKlaimCCPp.vue?vue&type=template&id=344ff7a6&"
import script from "./InformasiKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./InformasiKlaimCCPp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports